import { Patient, PatientUpdateIdentityDocumentCommand } from '@dreryk/egabinet-patient-frontend-api';
import { IdentityDocument } from '@dreryk/egabinet-patient-published-language-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { identityDocumentTranslationKeys } from '../../../../../../../../translations';
import { createIdentityDocumentTypeVisitor, getIdentityDocumentType } from '../../selector/IdentityDocumentTypeField';

import {
   PassportIdentityDocumentEnterFormBean,
   PassportIdentityDocumentEnterFormController,
} from './PassportIdentityDocumentEnterForm';

type PassportIdentityDocumentEnterModalConfirmButtonProps = Pick<
   PassportIdentityDocumentEnterFormController,
   'handleSubmit'
> & {
   readonly patientId: number;
   readonly onIdentityDocumentEntered: (patient: Patient) => Promise<void>;
   readonly onSuccess: VoidFunction;
};

export const PassportIdentityDocumentEnterModalConfirmButton = (
   props: PassportIdentityDocumentEnterModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: updatePatientIdentityDocument } = useCqrsCommand<
      Patient,
      PassportIdentityDocumentEnterFormBean
   >(
      (parameters) => {
         const command = new PatientUpdateIdentityDocumentCommand();
         const identityDocumentTypeVisitor = createIdentityDocumentTypeVisitor(parameters.identityDocumentType);
         command.id = props.patientId;
         command.identityDocument = IdentityDocument.of(
            getIdentityDocumentType(identityDocumentTypeVisitor),
            parameters.identityDocumentValue!,
            parameters.passportCountry!,
            parameters.passportValidTo!
         );
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               identityDocumentTranslationKeys.passport.enter.modal.saveAction.identityDocumentUpdated
            );
         },
      }
   );

   const handleClick = props.handleSubmit(async (data) => {
      const patient = await updatePatientIdentityDocument(data);
      try {
         await props.onIdentityDocumentEntered(patient);
      } finally {
         props.onSuccess();
      }
   });

   return (
      <ModalConfirmButton
         label={identityDocumentTranslationKeys.passport.enter.modal.saveAction.label}
         onClick={handleClick}
      />
   );
};
